import React, { Fragment, useEffect, useState } from 'react'
import { Box, Container, Grid, Typography } from '@mui/material'
import { Dialog, Transition } from '@headlessui/react';
import {
    HomeIcon,
    MenuIcon,
    CashIcon,
    ClockIcon,
    XIcon,
} from '@heroicons/react/outline'
import Farms from 'views/Farms';
import LandingPage from 'views/LandingPage';
import { NavLink, Route, Routes, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Pools from 'views/Pools';
import { Button } from '@pancakeswap/uikit';
import { useWeb3React } from '@web3-react/core';
import ConnectModal from 'views/Pools/components/Modal/ConnectModal';
import drivenwap from '../../assets/images/drivenwap.svg';
import { useDispatch, useSelector } from "react-redux";
import { setPidx, setWidx } from "store/IndexSlice";
import Balance from 'components/Balance';
import staking from '../../assets/images/staking.svg'
import { ethers } from 'ethers';
import { getLockUpAddress } from 'utils/addressHelpers';
import { getDrivenContract } from 'utils/contractHelpers';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const ConnectButton = styled(Button)`
  -webkit-box-align: center;
  align-items: center;
  border: 0px;
  border-radius: 8px;
  box-shadow: rgb(14 14 44 / 40%) 0px -1px 0px 0px inset;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 40px;
  padding: 0px 20px;
  background-color: #00FED9;
  color: black;
  &:hover {
    background-color: #00FED9;
  }
`;



function SideBar() {
    // useEffect(()=>{
    //     document.title='Home | DRIVENswap V2.0'
    // });
    const widx = useSelector((state: any) => state.Index.widx)
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const { error, connector, activate, deactivate, library, active, account } = useWeb3React();
    const [loading, setLoading] = React.useState(false);


    const location = useLocation();
    // const [open, setOpen] = React.useState(widx);
    // const handleClose = () => setOpen(false);
    // Redux use
    const dispatch = useDispatch()
    const handleOpen = () => {

        dispatch(setWidx(true))
    }
    const handleClose = () => {
        dispatch(setWidx(false))
    }
    const [marqueeData, setmarqueeData] = useState([])
    const [price, setPrice] = useState(0)
    const [TVL, setTVL] = useState(0)
    useEffect(() => {
        setTimeout(() => {
            async function fetchData() {
                let rspData = await fetch(
                    `https://5ptg6cq3g4.execute-api.us-east-1.amazonaws.com/v1`,
                    {
                        method: "get",
                    }
                );
                const row = await rspData.json()
                const contract = getDrivenContract(library);
                const bal = parseFloat(ethers.utils.formatUnits(await contract.balanceOf(getLockUpAddress()), 18));
                const totalSupply = parseFloat(ethers.utils.formatUnits(await contract.totalSupply(), 18));
                row.stakedPercentage = ((bal/totalSupply)*100).toFixed(3);
                setTVL(bal*parseFloat(row.price.substring(1))) 
                setPrice(parseFloat(row.price.substring(1)));
                setmarqueeData(row);
            }
            fetchData();
        }, 1000);
        // setTimeout(fetchData, 1000);
    }, [])

    const navigation = [
        { name: 'Home', NavLink: '/', icon: HomeIcon, current: location.pathname === "/" ? true : false },
        { name: 'Pools', NavLink: 'pool', icon: ClockIcon, current: location.pathname === "/pool" ? true : false },
        { name: 'Farms', NavLink: 'farm', icon: CashIcon, current: location.pathname === "/farm" ? true : false },
    ]
    const pidx = useSelector((state: any) => state.Index.processidx);
    const disconnectWallet = () => {
        deactivate();
        dispatch(setPidx(pidx + 1))
    }


    return (
        <>
            {
                location.pathname === "/"
                    ?
                    <title>Home | DRIVENswap V2.0</title>
                    :
                    ''
            }
            {
                location.pathname === "/pool"
                    ?
                    <title>Pools | DRIVENswap V2.0</title>
                    :
                    ''
            }
            {
                location.pathname === "/farm"
                    ?
                    <title>Farms | DRIVENswap V2.0</title>
                    :
                    ''
            }
            <div className="h-screen flex">
                <Transition.Root show={sidebarOpen} as={Fragment}>
                    <Dialog as="div" className="relative z-40 lg:hidden" onClose={setSidebarOpen}>
                        <Transition.Child
                            as={Fragment}
                            enter="transition-opacity ease-linear duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="transition-opacity ease-linear duration-300"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
                        </Transition.Child>

                        <div className="fixed inset-0 flex z-40">
                            <Transition.Child
                                as={Fragment}
                                enter="transition ease-in-out duration-300 transform"
                                enterFrom="-translate-x-full"
                                enterTo="translate-x-0"
                                leave="transition ease-in-out duration-300 transform"
                                leaveFrom="translate-x-0"
                                leaveTo="-translate-x-full"
                            >
                                {/* <Dialog.Panel className="relative flex-1 flex flex-col max-w-xs w-full bg-gray-800 focus:outline-none"> */}
                                <Dialog.Panel className="relative  flex flex-col  w-2/4 bg-gray-800 focus:outline-none">
                                    <Transition.Child
                                        as={Fragment}
                                        enter="ease-in-out duration-300"
                                        enterFrom="opacity-0"
                                        enterTo="opacity-100"
                                        leave="ease-in-out duration-300"
                                        leaveFrom="opacity-100"
                                        leaveTo="opacity-0"
                                    >
                                        <div className="absolute top-0 right-0 -mr-12 pt-2">
                                            <button
                                                type="button"
                                                className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none "
                                                onClick={() => setSidebarOpen(false)}
                                            >
                                                <span className="sr-only">Close sidebar</span>
                                                <XIcon className="h-6 w-6 text-white" style={{ color: '#00FED9' }} aria-hidden="true" />
                                            </button>
                                        </div>
                                    </Transition.Child>
                                    <div className="flex-1 h-0  overflow-y-auto">
                                        <div className="flex-shrink-0 flex items-center px-4 py-4">
                                            <img
                                                // className="max-h-full w-9/12"
                                                src={drivenwap}
                                                alt="driven"
                                                width="170px"
                                                height="40px"

                                            />
                                        </div>
                                        <div className="flex-shrink-0 flex items-center ">
                                            <Box sx={{ flexGrow: 1, py: 2, textAlign: 'center', borderTop: '1px solid #00FED9', borderBottom: '1px solid #00FED9' }}>
                                                <Box sx={{ whiteSpace: 'nowrap', fontSize: '14px', color: '#B1B3CB', fontWeight: 800 }}>DRIVENx Live Price</Box>
                                                <Box sx={{ fontSize: '27px', color: 'rgb(0, 254, 217)', fontWeight: 800 }}>{(marqueeData["price"])}</Box>
                                            </Box>
                                        </div>
                                        <nav aria-label="Sidebar" className="mt-5">
                                            <div className="px-2 space-y-1">
                                                {navigation.map((item) => (
                                                    <NavLink
                                                        key={item.name}
                                                        to={item.NavLink}
                                                        className={classNames(
                                                            item.current
                                                                ? 'bg-gray-900 text-white'
                                                                : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                                            'group flex items-center px-2 py-2 text-sm font-medium rounded-md',
                                                        )}
                                                    >
                                                        <item.icon
                                                            className={classNames(
                                                                item.current ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-300',
                                                                'mr-3 flex-shrink-0 h-6 w-6'
                                                            )}
                                                            aria-hidden="true"
                                                        />
                                                        {item.name}
                                                    </NavLink>
                                                ))}
                                                <a className='text-gray-300 hover:bg-gray-700 hover:text-white group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full cursor-pointer gap-3' href='https://whitepaper.drivenecosystem.com/our-ecosystem/drivenswap-v2.0' target='_blank'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400 group-hover:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                                    </svg>
                                                    Docs
                                                </a>
                                            </div>
                                        </nav>
                                    </div>
                                    {/* <div className="flex-shrink-0 flexp-4">
                                        <ConnectButton disabled={loading} onClick={() => setOpen(!open)}>{active ? account.substring(0, 4) + "..." + account.substring(account.length - 4) : "Connect Wallet"} </ConnectButton>
                                    </div> */}
                                </Dialog.Panel>
                            </Transition.Child>
                            <div className="flex-shrink-0 w-14" aria-hidden="true">
                                {/* Force sidebar to shrink to fit close icon */}
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>

                {/* Static sidebar for desktop */}
                <div className="hidden lg:flex lg:flex-shrink-0">
                    <div className="flex flex-col w-64 pb-0">
                        {/* Sidebar component, swap this element with another sidebar if you like */}
                        <div className="flex-1 flex flex-col min-h-screen bg-gray-800">
                            <div className="flex-1 flex flex-col  overflow-y-auto">
                                <div className="flex items-center flex-shrink-0 px-4 py-4 justify-center">
                                    <img
                                        className="max-h-full w-3/4"
                                        src={drivenwap}
                                        alt="Driven"
                                        width="170px"
                                        height="40px"
                                    />
                                </div>
                                <div className="flex-shrink-0 flex items-center ">
                                    <Box sx={{ flexGrow: 1, py: 2, textAlign: 'center', borderTop: '1px solid', borderBottom: '1px solid', borderColor: 'rgba(0, 254, 217, 0.4)' }}>
                                        <Box sx={{ whiteSpace: 'nowrap', fontSize: '14px', color: '#B1B3CB', fontWeight: 800 }}>DRIVENx Live Price</Box>
                                        <Box sx={{ fontSize: '27px', color: 'rgb(0, 254, 217)', fontWeight: 800 }}>{(marqueeData["price"])}</Box>
                                    </Box>
                                </div>
                                <nav className="mt-5 flex-1" aria-label="Sidebar">
                                    <div className="px-2 space-y-1">
                                        {navigation.map((item) => (
                                            <NavLink
                                                key={item.name}
                                                to={item.NavLink}
                                                className={classNames(
                                                    item.current
                                                        ? 'bg-gray-900 text-white'
                                                        : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                                    'group flex items-center px-2 py-2 text-sm font-medium rounded-md',

                                                )}
                                            >
                                                <item.icon
                                                    className={classNames(
                                                        item.current ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-300',
                                                        'mr-3 flex-shrink-0 h-6 w-6'
                                                    )}
                                                    aria-hidden="true"
                                                />
                                                {item.name}
                                            </NavLink>
                                        ))}
                                        <a className='text-gray-300 hover:bg-gray-700 hover:text-white group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full cursor-pointer gap-3' href='https://whitepaper.drivenecosystem.com/our-ecosystem/drivenswap-v2.0' target='_blank'>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400 group-hover:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                            </svg>
                                            Docs
                                        </a>
                                    </div>

                                </nav>
                            </div>
                            <div className="items-center flex-shrink-0 flex p-4 justify-center">
                                <ConnectButton disabled={loading} onClick={active ? disconnectWallet : handleOpen}>{active ? account.substring(0, 4) + "..." + account.substring(account.length - 4) : "Connect Wallet"} </ConnectButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col min-w-0 flex-1 overflow-hidden">
                    <div className="lg:hidden">
                        <div className="flex items-center justify-between bg-gray-50 px-4 py-1.5" style={{ backgroundColor: 'rgb(0,32,47)' }}>
                            <div>
                                <button
                                    type="button"
                                    className="-mr-3 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900"
                                    onClick={() => setSidebarOpen(true)}
                                    style={{ float: 'right', color: '#00FED9' }}
                                >
                                    <span className="sr-only">Open sidebar</span>
                                    <MenuIcon className="h-6 w-6" aria-hidden="true" />
                                </button>

                            </div>
                            <div className="flex-shrink-0 flexp-4">
                                <ConnectButton disabled={loading} onClick={active ? disconnectWallet : handleOpen}>{active ? account.substring(0, 4) + "..." + account.substring(account.length - 4) : "Connect Wallet"} </ConnectButton>
                            </div>
                        </div>
                    </div>
                    <div className="flex-1 relative z-0 flex overflow-hidden">
                        <main className="flex-1 relative z-0 overflow-y-auto focus:outline-none xl:order-last">
                            {/* Start main area*/}
                            <div className="max-w-full mx-auto">
                                <Routes>
                                    <Route path='/' element={<LandingPage apidata={marqueeData}  TVL={TVL}/>} />
                                    <Route path='/pool' element={<Pools price={price} />} />
                                    <Route path='/farm' element={<Farms />} />
                                </Routes>
                            </div>
                            {/* End main area */}
                        </main>

                    </div>
                </div>
            </div>
            <ConnectModal open={widx} onClose={handleClose}></ConnectModal>
        </>
    )
}

export default SideBar;